import { cn } from '../../../lib/cn';
import { rungWeightStyle } from './rungStyles';

/** Fixed slot multiplier — lives outside the draggable row so it never re-renders during a drag. */
export function LadderWeightPill({
  weight,
  topWeight,
  highlighted = false
}: {
  weight: number;
  topWeight: number;
  highlighted?: boolean;
}) {
  const styles = rungWeightStyle(weight, topWeight);
  return (
    <div className="flex min-h-[64px] items-center py-3">
      <div
        className={cn(
          'grid h-[38px] w-[38px] shrink-0 place-items-center overflow-hidden rounded-xl transition-shadow',
          styles.pill,
          highlighted && 'ring-2 ring-accent ring-offset-2 ring-offset-white'
        )}
      >
        <span className={cn('text-base font-extrabold tracking-[-0.03em]', styles.text)}>{weight}×</span>
      </div>
    </div>
  );
}
